import { render, staticRenderFns } from "./proofreading.vue?vue&type=template&id=b3882db6&scoped=true"
import script from "./proofreading.vue?vue&type=script&lang=js"
export * from "./proofreading.vue?vue&type=script&lang=js"
import style0 from "./proofreading.vue?vue&type=style&index=0&id=b3882db6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3882db6",
  null
  
)

export default component.exports